import { storeToRefs } from 'pinia';
import useKillswitches from '~/modules/featureControl/composables/useKillswitches';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import { useBrand } from '~/composables/useBrand';
import { usePageData } from '~/composables/usePageData';
import useExperiments from '~/stores/useExperimentsStore';
import useProductImagesCtaActions from './useProductImagesCtaActions';
import { useModal } from '~/composables/utils/useModal';
import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import useConsolidatedMemberStore from '~/stores/useConsolidatedMemberStore';

export default function useVtoCta() {
  const { isMasterProductFlag, isModifaceEnabledFlag } = useProductFlags();
  const { killswitches } = useKillswitches();
  const { isShopTheSetExpEnabled } = useFeatureEligibility();
  const { isMcom } = useBrand();
  const { productId } = usePageData();
  const consolidatedStore = useConsolidatedMemberStore();
  const { memberFlags, selectedMember } = storeToRefs(consolidatedStore);

  const {
    experimentFlags: { isImageIndicatorStylingEnabled, isImageARIndicatorEnabled },
  } = useExperiments();

  const vtoEligible = computed(() => {
    const baseCondition = killswitches?.isModifaceEnabled && isMcom;
    if (isShopTheSetExpEnabled) {
      return baseCondition && memberFlags.value?.isModifaceEnabledFlag;
    }
    return baseCondition && isModifaceEnabledFlag && !isMasterProductFlag;
  });

  // TODO: investigate !isMemberOfMaster

  const init = async () => {
    if (vtoEligible.value && !isImageIndicatorStylingEnabled && !isImageARIndicatorEnabled) {
      const store = (await import('@nuxt-common/virtual-try-on-experience/app/stores/useVTOExpStore')).useVTOExpStore();
      const { addCtaItem } = useProductImagesCtaActions();
      const { open } = useModal();

      addCtaItem({
        customCssClass: 'font-small',
        id: 'vto',
        label: 'TRY IT<br>ON NOW',
        onClickHandler: () => {
          open('VTO');
          store.setProductId(isShopTheSetExpEnabled ? selectedMember.value : productId);
        },
      });
    }
  };

  return {
    init,
  };
}
